import * as hooks from './hooks';
import * as model from './model';
import * as actions from './actions';

export const authStore = {
  ...model,
  ...hooks,
  ...actions,
};
